export default [
  {
    name: "Вице-президент",
    text:
      "Экс-начальник отдела Министерства общего и профессионального образования РФ; автор научных работ, в том числе учебников для вузов; награжден медалями; увлекается поэзией",
    score: 3
  },
  {
    name: "Строитель",
    text:
      "Почетный работник науки и техники РФ, профессор Государственной академии повышения квалификации и переподготовки кадров для строительства и жилищно-коммунального комплекса",
    score: 3
  },
  {
    name: "Управленец",
    text:
      "Зам. заведующего кафедрой экономической теории, опубликовал 224 научных работы общим объемом более 1000 п.л., в том числе 12 монографий, 2 учебника и 7 учебных пособий",
    score: 3
  },
  {
    name: "Культуролог",
    text:
      "С 1992 г. – профессор кафедры экономики, предпринимательства и менеджмента, впоследствии кафедры менеджмента. С 1994 г. – член президиума Пермского научного центра УрО РАН",
    score: 3
  },
  {
    name: "Заслуженный",
    text:
      "Заслуженный деятель науки РФ, Заслуженный деятель науки Бурятии. Действительный член Академии гуманитарных наук и Международной академии информатизации",
    score: 2
  },
  {
    name: "Финансист",
    text:
      "Советник по экономике в администрации Казани. Лауреат премии Правительства Российской Федерации в области образования. Заслуженный деятель науки Республики Татарстан",
    score: 2
  },
  {
    name: "Хищник",
    text:
      "Ректор госуниверситета. Член правления Вольного экономического общества России. Первый заместитель председателя областной Думы",
    score: 2
  },
  {
    name: "Искусствовед",
    text:
      "Действительный член Петровской академии наук и искусств, Международной академии инвестиций и экономики строительства, Жилищно-коммунальной академии, член-корреспондент РАЕН",
    score: 2
  },
  {
    name: "Стратег",
    text:
      "Почётный работник науки и техники РФ. Профессор ВАК. Руководитель проектов и ведущий консультант на проектах, связанных со стратегическим управлением",
    score: 1
  },
  {
    name: "Бюджетник",
    text:
      "Член-корреспондент Международной Академии Информатизации, действительный член Академии Гуманитарных Наук, специалист в области бюджетных отношений",
    score: 1
  },
  {
    name: "Мастер спорта",
    text:
      "Победитель чемпионата Ракетных войск стратегического назначения. Преподаватель кафедры теории и организации физической подготовки Военного института физической культуры",
    score: 1
  },
  {
    name: "Программист",
    text:
      "Профессор, специализируется в области статистического анализа и моделирования систем обработки информации. Лауреат премии Правительства РФ",
    score: 1
  }
];
